// Action Types
export const FETCH_SPOT_CONTACTS_OPP_MAP_REQUEST = "FETCH_SPOT_CONTACTS_OPP_MAP_REQUEST";
export const FETCH_SPOT_CONTACTS_OPP_MAP_SUCCESS = "FETCH_SPOT_CONTACTS_OPP_MAP_SUCCESS";
export const FETCH_SPOT_CONTACTS_OPP_MAP_FAILURE = "FETCH_SPOT_CONTACTS_OPP_MAP_FAILURE";

// Action Creators
export const FetchSpotContactsOppMapRequest = ({opportunityIds,userId}) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_SPOT_CONTACTS_OPP_MAP_REQUEST,
      payload: { opportunityIds ,userId},
    });
  };
};
export const FetchSpotContactsOppMapSuccess = (data) => ({
  type: FETCH_SPOT_CONTACTS_OPP_MAP_SUCCESS,
  payload: data,
});
export const FetchSpotContactsOppMapFailure = (error) => ({
  type: FETCH_SPOT_CONTACTS_OPP_MAP_FAILURE,
  payload: error,
});
